// extracted by mini-css-extract-plugin
export var social = "social-module--social--q+NaO";
export var socialLink = "social-module--social-link--ZGmCx";